export const INFORMATION_ROUTES = {
  __ROOT__: '/information',
}
